'use client';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Replace-mode pagination for admin tables. The hosting page owns URL state
// (cursor in `?cursor=`); PagedTable renders the items + Older/Newer/Newest
// chevrons and notifies the page via onPageChange. The "Newer" direction is
// satisfied client-side via useCursorHistory — it stacks cursors as the user
// advances so the server stays forward-only (no `prevCursor` parameter).
import { useEffect } from 'react';
import { Button } from '../Button/Button';
import { Row } from '../server/layout/Row/index';
import { I } from '../system/icons';
import { useCursorHistory } from './useCursorHistory';
export function PagedTable({ page, currentCursor, onPageChange, children, historyKey, renderEmpty, }) {
    const history = useCursorHistory(historyKey);
    // The first page has nothing newer. A stack left over from another tab or
    // search under the same historyKey must not offer "Newer" there or stand in
    // for the empty state, so it is dropped on arriving at the first page. Keyed
    // on the cursor alone: "Older" pushes before its navigation lands, and that
    // entry must survive the render in between.
    const atFirstPage = currentCursor === null;
    const { reset: resetHistory } = history;
    useEffect(() => {
        if (currentCursor === null)
            resetHistory();
    }, [currentCursor, resetHistory]);
    const canGoBack = !atFirstPage && history.canGoBack;
    const onOlder = () => {
        if (!page.nextCursor)
            return;
        history.push(currentCursor);
        onPageChange(page.nextCursor);
    };
    const onNewer = () => {
        const prev = history.pop();
        onPageChange(prev);
    };
    const onNewest = () => {
        history.reset();
        onPageChange(null);
    };
    if (page.items.length === 0 && atFirstPage) {
        return _jsx(_Fragment, { children: renderEmpty?.() ?? null });
    }
    const showNewer = canGoBack;
    const showNewest = !atFirstPage;
    const showOlder = page.nextCursor !== null;
    return (_jsxs(_Fragment, { children: [children(page.items), _jsxs(Row, { justify: "space-between", align: "center", gap: "md", style: { paddingTop: 'var(--space-lg)' }, children: [_jsx("div", { children: showNewest ? (_jsx(Button, { variant: "ghost", size: "sm", onClick: onNewest, children: "Newest" })) : null }), _jsxs(Row, { gap: "sm", children: [showNewer ? (_jsx(Button, { variant: "secondary", size: "sm", icon: I.back, onClick: onNewer, children: "Newer" })) : null, showOlder ? (_jsx(Button, { variant: "secondary", size: "sm", iconRight: I.arrow, onClick: onOlder, children: "Older" })) : null] })] })] }));
}
//# sourceMappingURL=PagedTable.js.map